import { useQuery } from "@tanstack/react-query";
import { getCategoriesApi } from "../../../api/resources.api";
import type { Category, CategoriesResponse } from "../../../types";

export const useCategories = (params?: {
  model?: string;
  category_id?: number;
}) => {
  return useQuery<Category[], Error>({
    queryKey: ["categories", params],
    queryFn: async () => {
      const response: CategoriesResponse = await getCategoriesApi(params);

      if (!response?.status || !Array.isArray(response?.data)) {
        throw new Error("Invalid Categories data format");
      }

      return response.data;
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
